import { useCallback, useMemo } from "react"
import { useSingleBarGraphOption } from "./options"
import { useSingleBarGraphModel } from "./model"
import { numericValueFormat, percentFormat } from "../../common"
import { useTooltip } from "../../../components/toolTip"
import { useGrid } from "../../../components/grid"
import { textStyle } from "../../../../../constants"

type useSingleBarGraphRenderOptionProps<T> = {
	graphOption: ReturnType<typeof useSingleBarGraphOption<T>>
	graphData: ReturnType<typeof useSingleBarGraphModel<T>>
}
export const useSingleBarGraphRenderOption = <T,>({
	graphOption: {
		valueDef
	},
	graphData
}: useSingleBarGraphRenderOptionProps<T>) => {
  const tooltip = useTooltip({ trigger: 'item', valueDef })
  const grid = useGrid({})

  const seriesLabelFormatter = useCallback(
    (params: {
      seriesName?: string
      value?: number | null
    }) => {
      const value = params.value
      if (value === undefined || value === null) return ''
      let percent = ''
      if (graphData?.total && typeof value === 'number') {
        percent = '\n(' + percentFormat(null, (value * 100) / graphData.total, 1) + ')'
      }
      return params.seriesName + '\n' + numericValueFormat(value, 1, valueDef?.unit) + percent
    },
    [valueDef, graphData]
  )

  const series = useMemo(
    () => graphData?.series.map(
      (series) => ({
        id: series.code,
        name: series.name,
        type: 'bar',
        stack: 'total',
        barWidth: '100%',
        label: {
          show: true,
          formatter: seriesLabelFormatter,
          position: 'inside'
        },
        emphasis: {
          focus: 'series',
          blurScope: 'series'
        },
        data: [series.value],
        itemStyle: series.itemStyle ?? {}
      })
    ) || [],
    [graphData, seriesLabelFormatter]
  )
	
	return {
		//animation: false,
    tooltip,
    grid,
		xAxis: {
			type: 'value',
			label: {
				show: false
			},
			max: 'dataMax',
			show: false
		},
		yAxis: {
			show: false,
			type: 'category'
		},
		series,
		textStyle
	}
}
